import { QueryOptions } from "../../Common/useQuery";
import useUserQuery from "../../Common/useUserQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export interface SupplierDto {
  id: string;
  name: string;
  accountNumber?: string;
  addressStreet?: string;
  addressCity?: string;
  addressState?: string;
  addressPostalCode?: string;
  addressCountry?: string;
  emailAddresses?: string[];
}

const useGetSuppliers = (options?: QueryOptions<SupplierDto[]>) => {
  const business = useSelectedBusiness();

  return useUserQuery<SupplierDto[]>(
    { path: `/api/businesses/${business.id}/suppliers` },
    options);
}

export default useGetSuppliers;
